import { render, staticRenderFns } from "./OrderDeliverySupport.vue?vue&type=template&id=751dbbe1"
import script from "./OrderDeliverySupport.js?vue&type=script&lang=js&external"
export * from "./OrderDeliverySupport.js?vue&type=script&lang=js&external"
import style0 from "./OrderDeliverySupport.vue?vue&type=style&index=0&id=751dbbe1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports